import React, { useState, useEffect } from "react"
import crossfilter from "crossfilter2"
import moment from "moment"

import { IfFulfilled, IfPending, useAsync } from "react-async"
import _ from "lodash"
const DataContext = React.createContext([{}, () => {}])

const fetchByStateData = async () => {
  const response = await fetch(
    "https://api.covidtracking.com/api/v1/states/daily.json",
    {
      headers: {
        Accept: "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  )
  const responseBody = await response.json()
  const filtered = responseBody.filter(d => !_.isEmpty(d.dateChecked))
  filtered.forEach(it => (it["dateCheckedMoment"] = moment(it["dateChecked"])))
  filtered.sort((a, b) => a.dateCheckedMoment.diff(b.dateCheckedMoment))
  filtered.forEach(
    it => (it["dateChecked"] = it["dateCheckedMoment"].format("YYYY-MM-DD"))
  )

  return filtered
}

const DataContextProvider = ({ children }) => {
  const dataByState = useAsync(fetchByStateData)
  const [selectedStates, setSelectedStates] = useState(["CA"])
  const [dates, setDates] = useState([
    moment().add(-30, "day").format("YYYY-MM-DD"),
    moment().format("YYYY-MM-DD"),
  ])

  const onDateRelayout = eventData => {
    const range0 = eventData["xaxis.range[0]"]
    const range1 = eventData["xaxis.range[1]"]
    if (range0 && range1) {
      const start = moment(range0).format("YYYY-MM-DD")
      const end = moment(range1).format("YYYY-MM-DD")
      setDates([start, end])
    }
  }
  const resetDates = () => {
    setDates([null, null])
  }

  const datesEmpty = () => {
    return dates[0] == null || dates[1] == null
  }

  return (
    <DataContext.Provider
      value={{
        data: dataByState,
        selectedStates,
        setSelectedStates,
        dates,
        setDates,
        onDateRelayout,
        resetDates,
        datesEmpty,
      }}
    >
      <IfPending state={dataByState}>Loading...</IfPending>
      <IfFulfilled state={dataByState}>{children}</IfFulfilled>
    </DataContext.Provider>
  )
}

export { DataContext, DataContextProvider }
